export default __webpack_public_path__ + "static/media/agustin7.73352d74.png";